import moment from "moment";
import { RequisitionModelSerializer } from "../recoil/types";

export const getReqDisplayDate = (
  requisition: RequisitionModelSerializer,
): string =>
  requisition.collection_date
    ? moment(requisition.collection_date).format("MMMM Do, YYYY")
    : moment(requisition.date_received).format("MMMM Do, YYYY");

/**
 * Format a date string as MM/DD/YYYY for the results tracker.
 *
 * Dates from the API can be date-only (`YYYY-MM-DD`) or full ISO timestamps
 * (e.g. `provider_released_time`). Returns an empty string for null/invalid
 * input so callers can omit the date line entirely.
 */
export const formatTrackerDate = (date: string | null | undefined): string => {
  if (!date) {
    return "";
  }
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format("MM/DD/YYYY") : "";
};
